module.exports = __webpack_public_path__ + "static/804802532.c9ff90de.jpg";